export default {
    routerName: '角色详情',
    role: {
        name: '角色名',
        code: '代号',
        authority: '权限',
        sortOrder: '排序',
        status: '状态',
        open: '启用',
        close: '停用',
        createBy: '创建者',
        createTime: '创建时间',
        updateBy: '更新者',
        updateTime: '更新时间',
        remark: '备注',
    },
    menu: {
        menuDistribute: '分配',
    },
};
